import React from 'react';
import PropTypes from 'prop-types';

export const VerticalDivider = () => <div className="border-l border-dark-fill-blue border-solid" />;

export const TwoPanelCardBody = ({ firstPanel, secondPanel }) => (
  <div className="flex flex-col p-6">
    <div className="flex space-x-6">
      <div className="w-1/2">
        {firstPanel}
      </div>
      <VerticalDivider />
      <div className="w-1/2">
        {secondPanel}
      </div>
    </div>
  </div>
);

TwoPanelCardBody.propTypes = {
  firstPanel: PropTypes.node.isRequired,
  secondPanel: PropTypes.node.isRequired,
};

/* all children should be LineItems */
export const DetailList = ({ children }) => (
  <dl className="m-0 grid grid-cols-2 gap-x-8 gap-y-2">
    {children}
  </dl>
);

DetailList.propTypes = {
  children: PropTypes.node.isRequired,
};
